import React, { useState, useEffect, useCallback } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";
import axiosInstance from "../../utils/axiosInstance";
import AppSpinner from '../Spinner/AppSpinner';
import ReloadButton from '../LoadingButtons/ReloadButton';
import styles from '../GroupEntryModal/GroupEntryModal.module.css';
import LectureDetailModal from '../LectureDetail/LectureDetail';
import PageInfoModal from '../PageInfoModal/PageInfoModal';

const DERSLER_INFO_ITEMS = [
  { icon: 'collection', text: 'Sol sütunda qrupun sillabusuna aid bütün təlimlər (kurslar) sıralanır — birini seçin.' },
  { icon: 'folder2-open', text: 'Orta sütunda seçilmiş təlimin bölmələri görünür — bölməyə klik edərək dərsləri açın.' },
  { icon: 'file-earmark-text', text: 'Sağ sütunda seçilmiş bölmənin dərsləri görünür — dərsə klik edərək detalları açın.' },
  { icon: 'check-circle-fill', text: 'Dərs detalında "Keçildi" düyməsi ilə həmin dərsi bu qrup üçün tamamlanmış kimi qeyd edə bilərsiniz.' },
  { icon: 'file-earmark-slides', text: 'Dərs detalında slaydlar, tapşırıqlar, testlər və AI izahları tablarına baxa bilərsiniz.' },
  { icon: 'download', text: 'Fayl kartlarındakı endir düyməsi ilə materialları cihazınıza yükləyə bilərsiniz.' },
  { icon: 'arrow-clockwise', text: 'Yenilə (bənövşəyi) düyməsi ilə təlim siyahısını yenidən yükləyə bilərsiniz.' },
];

// group.sector: 'az' | 'rus' | 'eng'  →  API sector: 'Az' | 'Rus' | 'Eng'
const sectorLangMap = { az: 'Az', rus: 'Rus', eng: 'Eng' };

const parseLang = (str, lang = 'Az') => {
  if (!str) return '';
  const regex = new RegExp(`${lang}:::([\\s\\S]*?)(?=(?:Az|Rus|Eng):::|$)`);
  const match = str.match(regex);
  if (match) return match[1].trim();
  return str;
};

const filterBySector = (arr, apiSector) => {
  if (!arr || !apiSector) return arr || [];
  return arr.filter(item => item.sector === apiSector);
};

/* ══════════ TƏSDİQ MODALI ══════════ */
const ConfirmModal = ({ lectureName, onConfirm, onCancel }) => (
  <div
    style={{
      position: 'fixed', inset: 0, zIndex: 99998,
      background: 'rgba(15, 23, 42, 0.45)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}
    onClick={onCancel}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: '#fff', borderRadius: 16, padding: '28px 20px 20px',
        width: 'min(360px, calc(100vw - 32px))', boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
        animation: 'fadeInModal 0.2s cubic-bezier(0.16,1,0.3,1)'
      }}
    >
      <div style={{
        width: 52, height: 52, borderRadius: '50%', margin: '0 auto 16px',
        background: '#dcfce7', border: '2px solid #86efac',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <i className="bi bi-check-circle-fill" style={{ fontSize: 26, color: '#10b981' }}></i>
      </div>

      <h6 style={{ textAlign: 'center', fontWeight: 800, color: '#111827', marginBottom: 10, fontSize: 15 }}>
        Dərsi keçilmiş kimi işarələ?
      </h6>

      <p style={{ textAlign: 'center', fontSize: 12, color: '#6b7280', marginBottom: 8, lineHeight: 1.6 }}>
        <strong style={{ color: '#374151' }}>"{lectureName}"</strong> dərsi bu qrup üçün keçilmiş kimi qeyd olunacaq.
      </p>

      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center',
        background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)',
        borderRadius: 8, padding: '8px 14px', marginBottom: 22
      }}>
        <i className="bi bi-exclamation-triangle-fill" style={{ color: '#f59e0b', fontSize: 13 }}></i>
        <span style={{ fontSize: 11, color: '#92400e', fontWeight: 600 }}>
          Bu əməliyyatı geri qaytarmaq mümkün deyil
        </span>
      </div>

      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={onCancel}
          style={{
            flex: 1, padding: '10px', borderRadius: 9, border: '1px solid #e5e7eb',
            background: '#f9fafb', color: '#374151', fontWeight: 700, fontSize: 13,
            cursor: 'pointer', transition: 'background 0.15s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
          onMouseLeave={e => e.currentTarget.style.background = '#f9fafb'}
        >
          Ləğv et
        </button>
        <button
          onClick={onConfirm}
          style={{
            flex: 1, padding: '10px', borderRadius: 9, border: 'none',
            background: '#10b981', color: '#fff', fontWeight: 700, fontSize: 13,
            cursor: 'pointer', transition: 'background 0.15s'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#059669'}
          onMouseLeave={e => e.currentTarget.style.background = '#10b981'}
        >
          Təsdiq et
        </button>
      </div>
    </div>
  </div>
);

/* ══════════ FILE CARD ══════════ */
const FileCard = ({ item, color, icon, downloadUrl, baxUrl }) => {
  const [downloading, setDownloading]   = React.useState(false);
  const [hovered, setHovered]           = React.useState(false);
  const [previewOpen, setPreviewOpen]       = React.useState(false);
  const [previewFullscreen, setPreviewFullscreen] = React.useState(false);
  const [previewUrl, setPreviewUrl]     = React.useState(null);
  const [previewType, setPreviewType]   = React.useState('');
  const [previewLoading, setPreviewLoading] = React.useState(false);

  const handleDownload = () => {
    if (downloading) return;
    setDownloading(true);
    axiosInstance.get(downloadUrl, { responseType: 'blob' })
      .then(res => {
        const blob = res.data;
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = item.fileName || item.name || item.fileUuidName;
        a.click();
        URL.revokeObjectURL(a.href);
      })
      .catch(() => {})
      .finally(() => setDownloading(false));
  };

  const handlePreview = () => {
    setPreviewOpen(true);
    setPreviewUrl(null);
    setPreviewType('');
    setPreviewLoading(true);
    axiosInstance.get(baxUrl || downloadUrl, { responseType: 'blob' })
      .then(res => {
        const contentType = res.data.type || '';
        setPreviewUrl(URL.createObjectURL(res.data));
        setPreviewType(contentType);
      })
      .catch(() => setPreviewUrl(null))
      .finally(() => setPreviewLoading(false));
  };

  const handleClosePreview = () => {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setPreviewOpen(false);
    setPreviewUrl(null);
    setPreviewType('');
    setPreviewFullscreen(false);
  };

  return (
  <>
  <div style={{
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '10px 14px', background: '#fff', borderRadius: 8,
    border: '1px solid var(--border)', marginBottom: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)', transition: 'box-shadow 0.15s'
  }}
    onMouseEnter={e => e.currentTarget.style.boxShadow = `0 2px 8px ${color}22`}
    onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'}
  >
    <div style={{
      width: 38, height: 38, borderRadius: 8, flexShrink: 0,
      background: `${color}15`, border: `1px solid ${color}33`,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <i className={`bi bi-${icon}`} style={{ fontSize: 18, color }}></i>
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 2 }}>
        {item.name}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        {item.fileUuidName && (
          <span style={{ fontSize: 10, color: 'var(--text-muted)', fontFamily: 'monospace' }}>
            {item.fileUuidName}
          </span>
        )}
        {item.sector && (
          <span style={{
            fontSize: 10, fontWeight: 700, padding: '1px 6px',
            background: '#f3f4f6', color: 'var(--text-muted)', borderRadius: 4
          }}>{item.sector.toUpperCase()}</span>
        )}
      </div>
    </div>
    {item.fileUuidName && (
      <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
        <button
          title="Bax"
          onClick={handlePreview}
          style={{
            width: 32, height: 32, border: '1px solid #c4b5fd', borderRadius: 8,
            background: '#f5f3ff', color: '#7c3aed',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'all 0.15s'
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#7c3aed'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#f5f3ff'; e.currentTarget.style.color = '#7c3aed'; }}
        >
          <i className="bi bi-eye" style={{ fontSize: 14 }}></i>
        </button>
        <button
          title="Yüklə"
          onClick={handleDownload}
          disabled={downloading}
          style={{
            width: 32, height: 32, border: `1px solid ${color}44`, borderRadius: 8,
            background: !downloading && hovered ? color : downloading ? `${color}20` : `${color}10`,
            color: !downloading && hovered ? '#fff' : color,
            cursor: downloading ? 'default' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s'
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {downloading
            ? <i className="bi bi-arrow-clockwise" style={{ fontSize: 14, animation: 'spin 0.8s linear infinite' }}></i>
            : <i className="bi bi-download" style={{ fontSize: 14 }}></i>
          }
        </button>
      </div>
    )}
  </div>

  {previewOpen && (
    <div onClick={handleClosePreview} style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff',
        width: previewFullscreen ? '100vw' : '88vw',
        height: previewFullscreen ? '100vh' : '88vh',
        borderRadius: previewFullscreen ? 0 : 10,
        display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: previewFullscreen ? 'none' : '0 8px 40px rgba(0,0,0,0.3)',
        transition: 'width 0.2s, height 0.2s, border-radius 0.2s',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '10px 16px', borderBottom: '1px solid #e5e7eb',
          background: '#f9fafb', flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="bi bi-eye-fill" style={{ color: '#7c3aed', fontSize: 14 }}></i>
            <span style={{ fontWeight: 700, fontSize: 13, color: '#111827' }}>{item.name}</span>
            {item.sector && (
              <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '1px 6px', borderRadius: 3, fontSize: 10, fontWeight: 600, border: '1px solid #bfdbfe' }}>
                {item.sector}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={handleDownload} disabled={downloading} style={{
              display: 'inline-flex', alignItems: 'center', gap: 4,
              background: '#f0f9ff', color: '#0369a1',
              border: '1px solid #bae6fd', borderRadius: 5,
              padding: '4px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
            }}>
              <i className="bi bi-download" style={{ fontSize: 11 }}></i> Yüklə
            </button>
            <button
              onClick={() => setPreviewFullscreen(f => !f)}
              title={previewFullscreen ? 'Kiçilt' : 'Tam ekran'}
              style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 28, height: 28, borderRadius: 6,
                background: '#f0fdf4', color: '#16a34a',
                border: '1px solid #bbf7d0', cursor: 'pointer', fontSize: 13,
              }}
            >
              <i className={`bi ${previewFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'}`} />
            </button>
            <button onClick={handleClosePreview} style={{
              width: 28, height: 28, borderRadius: 6,
              background: '#fee2e2', color: '#ef4444',
              border: '1px solid #fecaca', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 14, fontWeight: 700,
            }}>✕</button>
          </div>
        </div>

        <div style={{ flex: 1, minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
          {previewLoading ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, color: '#6b7280' }}>
              <i className="bi bi-arrow-clockwise" style={{ fontSize: 28, animation: 'spin 0.8s linear infinite' }}></i>
              <span style={{ fontSize: 13 }}>Fayl yüklənir...</span>
            </div>
          ) : !previewUrl ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, color: '#9ca3af' }}>
              <i className="bi bi-exclamation-circle" style={{ fontSize: 32 }}></i>
              <span style={{ fontSize: 13 }}>Fayl yüklənmədi</span>
            </div>
          ) : previewType.includes('pdf') ? (
            <iframe src={previewUrl} title={item.name} style={{ width: '100%', height: '100%', border: 'none' }} />
          ) : previewType.startsWith('image/') ? (
            <img src={previewUrl} alt={item.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 4 }} />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, color: '#6b7280', textAlign: 'center', padding: 32 }}>
              <i className="bi bi-file-earmark-text" style={{ fontSize: 48, color: '#d1d5db' }}></i>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Bu fayl növü birbaşa önizlənmir</span>
              <span style={{ fontSize: 12, color: '#9ca3af' }}>Faylı yükləyib açın</span>
              <button onClick={handleDownload} style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                background: color, color: '#fff', border: 'none',
                borderRadius: 6, padding: '6px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
              }}>
                <i className="bi bi-download"></i> Yüklə
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )}
  </>
  );
};

/* ══════════ AI TASK CARD ══════════ */
const AiTaskCard = ({ item, index }) => {
  const [downloading, setDownloading] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);

  const handleDownload = () => {
    if (downloading) return;
    if (item.fileUuidName) {
      setDownloading(true);
      axiosInstance.get(`${BASE_URL}/files/download-lecture-task/${item.fileUuidName}`, { responseType: 'blob' })
        .then(res => {
          const blob = res.data;
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = item.fileName || item.name || item.fileUuidName;
          a.click();
          URL.revokeObjectURL(url);
        })
        .catch(err => console.error('Yükləmə xətası:', err))
        .finally(() => setDownloading(false));
    } else {
      const text = [item.name, item.description].filter(Boolean).join('\n\n');
      const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${item.name || `calısma-${index + 1}`}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div style={{
      display: 'flex', gap: 12, padding: '10px 14px', background: '#fff',
      borderRadius: 8, border: '1px solid var(--border)', marginBottom: 8,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)', transition: 'box-shadow 0.15s'
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px #3b82f622'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'}
    >
      <div style={{
        width: 38, height: 38, borderRadius: 8, flexShrink: 0, alignSelf: 'flex-start',
        background: '#eff6ff', border: '1px solid #bfdbfe',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <i className="bi bi-journal-code" style={{ fontSize: 18, color: '#3b82f6' }}></i>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', marginBottom: item.description ? 4 : 0 }}>
          {item.name || `Çalışma ${index + 1}`}
        </div>
        {item.description && (
          <div style={{ fontSize: 11, color: '#4b5563', lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {item.description}
          </div>
        )}
        {item.sector && (
          <span style={{
            display: 'inline-block', marginTop: 4,
            fontSize: 10, fontWeight: 700, padding: '1px 6px',
            background: '#f3f4f6', color: 'var(--text-muted)', borderRadius: 4
          }}>{item.sector.toUpperCase()}</span>
        )}
      </div>
      <button
        title="Yüklə"
        onClick={handleDownload}
        disabled={downloading}
        style={{
          width: 32, height: 32, border: '1px solid #bfdbfe', borderRadius: 8,
          background: !downloading && hovered ? '#3b82f6' : downloading ? '#dbeafe' : '#eff6ff',
          color: !downloading && hovered ? '#fff' : '#3b82f6',
          cursor: downloading ? 'default' : 'pointer', flexShrink: 0,
          alignSelf: 'flex-start',
          display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s'
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {downloading
          ? <i className="bi bi-arrow-clockwise" style={{ fontSize: 14, animation: 'spin 0.8s linear infinite' }}></i>
          : <i className="bi bi-download" style={{ fontSize: 14 }}></i>
        }
      </button>
    </div>
  );
};

/* ══════════ QUIZ CARD ══════════ */
const QuizCard = ({ quiz }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 14px', background: '#fff', borderRadius: 8,
    border: '1px solid var(--border)', marginBottom: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
  }}>
    <div style={{
      width: 34, height: 34, borderRadius: 8, flexShrink: 0,
      background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.3)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <i className="bi bi-patch-question-fill" style={{ fontSize: 16, color: '#f59e0b' }}></i>
    </div>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)' }}>{quiz.name}</div>
      {quiz.description && (
        <div style={{ fontSize: 11, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {quiz.description}
        </div>
      )}
    </div>
    <span style={{
      fontSize: 10, fontWeight: 700, padding: '2px 8px',
      background: 'rgba(245,158,11,0.12)', color: '#f59e0b',
      border: '1px solid rgba(245,158,11,0.3)', borderRadius: 10, flexShrink: 0
    }}>{quiz.questions?.length || 0} sual</span>
  </div>
);

/* ══════════ EMPTY STATE ══════════ */
const EmptyState = ({ icon, text }) => (
  <div style={{ padding: '30px 16px', textAlign: 'center', color: '#9ca3af' }}>
    <i className={`bi bi-${icon}`} style={{ fontSize: 28, marginBottom: 8, display: 'block', color: '#d1d5db' }}></i>
    <p style={{ fontSize: 11, margin: 0 }}>{text}</p>
  </div>
);

/* ══════════ PANEL HEADER ══════════ */
const PanelHeader = ({ label }) => (
  <div style={{ padding: '7px 12px', borderBottom: '1px solid var(--border)', background: 'var(--bg-elevated)', flexShrink: 0 }}>
    <span style={{ fontSize: 10, fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px' }}>
      {label}
    </span>
  </div>
);

/* ══════════ İZAH KARTI ══════════ */
const ExplanationCard = ({ item, index }) => (
  <div style={{
    display: 'flex', gap: 12, padding: '12px 14px',
    background: '#fff', borderRadius: 8,
    border: '1px solid var(--border)', marginBottom: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)', transition: 'box-shadow 0.15s'
  }}
    onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(16,185,129,0.12)'}
    onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'}
  >
    <div style={{
      width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
      background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.25)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 11, fontWeight: 800, color: '#10b981', marginTop: 1
    }}>{index + 1}</div>
    <p style={{ margin: 0, fontSize: 12, color: 'var(--text-primary)', lineHeight: 1.7 }}>
      {typeof item === 'string' ? item : item.content || item.text || item.explanation || JSON.stringify(item)}
    </p>
  </div>
);

/* ══════════ DƏRS DETALİ ══════════ */
const LectureDetail = ({ lecture, onClose, apiSector, onRefreshLecture, onOpenManageModal }) => {
  const [explanations, setExplanations]         = useState([]);
  const [explanationsLoading, setExplanationsLoading] = useState(false);
  const [aiTasks, setAiTasks]                   = useState([]);
  const [aiTasksLoading]                        = useState(false);
  const [aiTasksFetched, setAiTasksFetched]     = useState(false);
  const [aiQuizzes, setAiQuizzes]               = useState([]);
  const [aiQuizzesLoading]                      = useState(false);
  const [aiQuizzesFetched, setAiQuizzesFetched] = useState(false);
  const [refreshLoading, setRefreshLoading]     = useState(false);

  const slides  = filterBySector(lecture.slides,  apiSector);
  const tasks   = filterBySector(lecture.tasks,   apiSector);
  const quizzes = filterBySector(lecture.quizzes, apiSector);

  useEffect(() => {
    setAiTasks([]);
    setAiTasksFetched(false);
    setAiQuizzes([]);
    setAiQuizzesFetched(false);
    setExplanations([]);

    let cancelled = false;
    setExplanationsLoading(true);
    apiFetch(`${BASE_URL}/lectures/get-content-from-ai/${lecture.id}/sector/${apiSector}`)
      .then(res => res.json())
      .then(data => {
        if (!cancelled) setExplanations(Array.isArray(data) ? data : data.explanations || data.content || data.items || []);
      })
      .catch(() => { if (!cancelled) setExplanations([]); })
      .finally(() => { if (!cancelled) setExplanationsLoading(false); });

    return () => { cancelled = true; };
  }, [lecture.id, apiSector]);


  const SectionLabel = ({ color, icon, label, count }) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      padding: '5px 8px', marginBottom: 8,
      background: `${color}12`, borderRadius: 6,
      borderLeft: `3px solid ${color}`
    }}>
      <i className={`bi bi-${icon}`} style={{ fontSize: 13, color }}></i>
      <span style={{ fontSize: 11, fontWeight: 800, color, textTransform: 'uppercase', letterSpacing: '0.8px' }}>
        {label}
      </span>
      {count > 0 && (
        <span style={{
          marginLeft: 'auto', fontSize: 10, fontWeight: 700,
          background: color, color: '#fff', borderRadius: 10, padding: '1px 7px'
        }}>{count}</span>
      )}
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff', overflow: 'hidden' }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '7px 12px', borderBottom: '1px solid var(--border)',
        background: 'var(--bg-elevated)', flexShrink: 0
      }}>
        <button onClick={onClose} style={{
          width: 24, height: 24, border: '1px solid var(--border)', borderRadius: 5,
          background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: 'var(--text-muted)', fontSize: 11, flexShrink: 0
        }}>
          <i className="bi bi-arrow-left"></i>
        </button>
        <span style={{ fontSize: 10, fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px', flex: 1 }}>
          Materiallar
        </span>
        {onOpenManageModal && (
          <button
            title="Dərslik idarəetmə modalını aç"
            onClick={onOpenManageModal}
            style={{
              height: 24,
              border: '1px solid var(--primary)',
              borderRadius: 6,
              background: 'var(--primary-glow)',
              color: 'var(--primary)',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              padding: '0 8px',
              fontSize: 10,
              fontWeight: 700,
              flexShrink: 0
            }}
          >
            <i className="bi bi-box-arrow-up-right" style={{ fontSize: 11 }}></i>
            İdarə et
          </button>
        )}
        {onRefreshLecture && (
          <button
            title="Yenilə"
            disabled={refreshLoading}
            onClick={async () => {
              setRefreshLoading(true);
              await onRefreshLecture(lecture.id);
              setRefreshLoading(false);
            }}
            style={{
              width: 24, height: 24, border: '1px solid var(--border)', borderRadius: 5,
              background: '#fff', cursor: refreshLoading ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'var(--text-muted)', fontSize: 12, flexShrink: 0,
              opacity: refreshLoading ? 0.6 : 1, transition: 'all 0.15s'
            }}
          >
            <i className={`bi bi-arrow-clockwise${refreshLoading ? ' spin-icon' : ''}`}></i>
          </button>
        )}
      </div>

      <div style={{ flex: 1, overflow: 'auto', background: '#fafafa', padding: '12px' }}>

        {/* ── Slaydlar ── */}
        <div style={{ marginBottom: 16 }}>
          <SectionLabel color="#2563eb" icon="file-earmark-slides-fill" label="Slaydlar" count={slides.length} />
          {slides.length === 0
            ? <EmptyState icon="file-earmark-slides" text="Slide yüklənməyib" />
            : slides.map(s => (
                <FileCard key={s.id} item={s} color="#2563eb" icon="file-earmark-slides-fill"
                  downloadUrl={`${BASE_URL}/files/download-lecture-slide/${s.fileUuidName}`}
                  baxUrl={s.fileUuidName.toLowerCase().endsWith('.pdf')
                    ? `${BASE_URL}/files/download-lecture-slide/${s.fileUuidName}`
                    : `${BASE_URL}/files/download-lecture-slide-pdf/${s.fileUuidName.replace(/\.[^.]+$/, '')}.pdf`} />
              ))
          }
        </div>

        {/* ── Çalışmalar ── */}
        <div style={{ marginBottom: 16 }}>
          <SectionLabel color="#3b82f6" icon="journal-code" label="Çalışmalar"
            count={tasks.length > 0 ? tasks.length : aiTasks.length} />
          {tasks.length > 0
            ? tasks.map((t, i) => <AiTaskCard key={t.id || i} item={t} index={i} />)
            : aiTasksLoading
              ? (
                <div style={{ padding: '20px 0', display: 'flex', justifyContent: 'center' }}>
                  <AppSpinner text="Çalışmalar hazırlanır..." />
                </div>
              )
              : aiTasks.length > 0
                ? aiTasks.map((t, i) => <AiTaskCard key={t.id || i} item={t} index={i} />)
                : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', gap: 10 }}>
                    <i className="bi bi-journal-code" style={{ fontSize: 28, color: '#d1d5db' }}></i>
                    <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: 0 }}>
                      {aiTasksFetched ? 'Bu dərs üçün çalışma tapılmadı' : 'Hələ ki çalışma yoxdur'}
                    </p>
                  </div>
                )
          }
        </div>

        {/* ── Testlər ── */}
        <div style={{ marginBottom: 16 }}>
          <SectionLabel color="#f59e0b" icon="patch-question-fill" label="Testlər"
            count={quizzes.length > 0 ? quizzes.length : aiQuizzes.length} />
          {quizzes.length > 0
            ? quizzes.map(q => <QuizCard key={q.id} quiz={q} />)
            : aiQuizzesLoading
              ? (
                <div style={{ padding: '20px 0', display: 'flex', justifyContent: 'center' }}>
                  <AppSpinner text="Testlər hazırlanır..." />
                </div>
              )
              : aiQuizzes.length > 0
                ? aiQuizzes.map(q => <QuizCard key={q.id} quiz={q} />)
                : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', gap: 10 }}>
                    <i className="bi bi-patch-question" style={{ fontSize: 28, color: '#d1d5db' }}></i>
                    <p style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', margin: 0 }}>
                      {aiQuizzesFetched ? 'Bu dərs üçün test tapılmadı' : 'Hələ ki test yoxdur'}
                    </p>
                  </div>
                )
          }
        </div>

        {/* ── İzahlar ── */}
        <div style={{ marginBottom: 16 }}>
          <SectionLabel color="#10b981" icon="lightbulb-fill" label="İzahlar" count={0} />
          {explanationsLoading
            ? (
              <div style={{ padding: '20px 0', display: 'flex', justifyContent: 'center' }}>
                <AppSpinner text="İzahlar yüklənir..." />
              </div>
            )
            : explanations.length === 0
              ? <EmptyState icon="lightbulb" text="Bu dərs üçün izah tapılmadı" />
              : explanations.map((item, i) => <ExplanationCard key={i} item={item} index={i} />)
          }
        </div>

      </div>
    </div>
  );
};

/* ══════════ LECTURE CHECKBOX ITEM ══════════ */
const LectureItem = ({ lec, lIdx, isActive, groupId, apiSector, onSelect, onCheckedChange }) => {
  const [checked, setChecked]           = useState(lec.checked || false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [showConfirm, setShowConfirm]   = useState(false);
  const [toastMsg, setToastMsg]         = useState(null); // { text, variant }

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    if (checked || checkLoading) return;
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    setCheckLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/lectures/checked-by-teacher`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ lectureId: lec.id, groupId, active: true })
      });

      if (res.ok) {
        setChecked(true);
        onCheckedChange && onCheckedChange(lec.id, true);
        setToastMsg({ text: 'Dəyişiklik uğurla yadda saxlanıldı', variant: 'success' });
      }
    } catch (_) {
    } finally {
      setCheckLoading(false);
    }
  };

  return (
    <>
      {showConfirm && (
        <ConfirmModal
          lectureName={parseLang(lec.name, apiSector)}
          onConfirm={handleConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}

      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 99999 }}>
        <Toast
          onClose={() => setToastMsg(null)}
          show={!!toastMsg}
          delay={4000}
          autohide
          bg={toastMsg?.variant}
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Sistem Mesajı</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toastMsg?.text}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div
        onClick={() => onSelect(lec)}
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '7px 12px 7px 16px',
          borderBottom: '1px solid #f3f4f6',
          cursor: 'pointer', userSelect: 'none',
          background: isActive ? 'rgba(168,85,247,0.08)' : 'transparent',
          borderLeft: `3px solid ${isActive ? 'var(--primary)' : checked ? '#10b981' : 'transparent'}`,
          transition: 'all 0.12s'
        }}
        onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = '#f3f0ff'; }}
        onMouseLeave={e => { e.currentTarget.style.background = isActive ? 'rgba(168,85,247,0.08)' : 'transparent'; }}
      >
        {/* Checkbox */}
        <div
          onClick={handleCheckboxClick}
          title={checked ? 'Bu dərs artıq keçilib' : 'Dərs keçildi kimi işarələ'}
          style={{
            width: 18, height: 18, borderRadius: 4, flexShrink: 0,
            border: `2px solid ${checked ? '#10b981' : '#d1d5db'}`,
            background: checked ? '#10b981' : '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: checked ? 'not-allowed' : checkLoading ? 'wait' : 'pointer',
            transition: 'all 0.15s', position: 'relative',
            opacity: checked ? 0.85 : 1
          }}
        >
          {checkLoading ? (
            <div style={{
              width: 8, height: 8, border: '1.5px solid #fff',
              borderTop: '1.5px solid transparent',
              borderRadius: '50%', animation: 'spin 0.6s linear infinite'
            }} />
          ) : checked ? (
            <i className="bi bi-check" style={{ fontSize: 11, color: '#fff', lineHeight: 1 }}></i>
          ) : null}
        </div>

        {/* Nömrə badge */}
        <span style={{
          width: 18, height: 18, borderRadius: 4, flexShrink: 0,
          background: isActive ? 'var(--primary)' : 'rgba(168,85,247,0.08)',
          color: isActive ? '#fff' : 'var(--primary)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 9, fontWeight: 700
        }}>{lIdx + 1}</span>

        {/* Dərs adı */}
        <span
          title={parseLang(lec.name, apiSector)}
          style={{
            fontSize: 11, fontWeight: isActive ? 700 : 600,
            color: isActive ? 'var(--primary)' : checked ? '#059669' : 'var(--text-primary)',
            flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
          }}>{parseLang(lec.name, apiSector)}</span>

        {/* Checked badge */}
        {checked && (
          <span style={{
            fontSize: 9, fontWeight: 700, padding: '1px 5px',
            background: 'rgba(16,185,129,0.12)', color: '#059669',
            border: '1px solid rgba(16,185,129,0.3)', borderRadius: 8, flexShrink: 0
          }}>Keçilib</span>
        )}

        <i className="bi bi-chevron-right" style={{ fontSize: 10, color: isActive ? 'var(--primary)' : '#d1d5db' }}></i>
      </div>
    </>
  );
};

/* ══════════ MAIN ══════════ */
const LectureManager = ({ groupId, sector }) => {
  const apiSector = sectorLangMap[sector?.toLowerCase()] || 'Az';
  const [trainings, setTrainings]             = useState([]);
  const [loading, setLoading]                 = useState(false);
  const [selected, setSelected]               = useState(null);
  const [sections, setSections]               = useState([]);
  const [sectionsLoading, setSectionsLoading] = useState(false);
  const [openSections, setOpenSections]       = useState({});
  const [lectures, setLectures]               = useState({});
  const [lecturesLoading, setLecturesLoading] = useState({});
  const [activeLecture, setActiveLecture]     = useState(null);
  const [activeSectionId, setActiveSectionId] = useState(null);
  const [showLectureDetailModal, setShowLectureDetailModal] = useState(false);

  // Responsivlik
  // mobile  < 768px  → bir panel, addım-addım
  // desktop >= 768px → bütün panellər yan-yana
  const getBreakpoint = () => window.innerWidth < 768 ? 'mobile' : 'desktop';
  const [bp, setBp] = useState(getBreakpoint);
  const [mobileStep, setMobileStep] = useState('trainings');

  const isMobile = bp === 'mobile';

  useEffect(() => {
    const onResize = () => setBp(getBreakpoint());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const fetchTrainings = async () => {
    const contractTrainingId = localStorage.getItem('activeContractTrainingId');
    if (!contractTrainingId) return;
    setLoading(true);
    try {
      const [res] = await Promise.all([
        apiFetch(`${BASE_URL}/trainings/contract-training/${contractTrainingId}`),
        new Promise((r) => setTimeout(r, 600)),
      ]);
      const data = await res.json();
      setTrainings(data.trainings || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchTrainings(); }, []);

  const fetchSections = useCallback(async (trainingId) => {
    setSectionsLoading(true);
    setSections([]);
    setOpenSections({});
    setLectures({});
    setActiveLecture(null);
    try {
      const res = await apiFetch(`${BASE_URL}/sections/training/${trainingId}`);
      const data = await res.json();
      setSections((data.sections || []).slice().sort((a, b) => (a.counter ?? 0) - (b.counter ?? 0)));
    } catch (e) { console.error(e); }
    finally { setSectionsLoading(false); }
  }, []);

  const fetchLectures = async (sectionId) => {
    if (lectures[sectionId]) return;
    if (!groupId) return;
    setLecturesLoading(p => ({ ...p, [sectionId]: true }));
    try {
      const res = await apiFetch(`${BASE_URL}/lectures/get-group-section-lectures-with-details`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sectionId, groupId })
      });
      const data = await res.json();
      setLectures(p => ({ ...p, [sectionId]: (data.lectures || []).slice().sort((a, b) => (a.counter ?? 0) - (b.counter ?? 0)) }));
    } catch (e) { console.error(e); }
    finally { setLecturesLoading(p => ({ ...p, [sectionId]: false })); }
  };

  const toggleSection = (sectionId) => {
    const isOpen = !openSections[sectionId];
    setOpenSections(p => ({ ...p, [sectionId]: isOpen }));
    if (isOpen) fetchLectures(sectionId);
  };

  const handleCheckedChange = (sectionId, lectureId, newValue) => {
    setLectures(prev => ({
      ...prev,
      [sectionId]: prev[sectionId].map(lec =>
        lec.id === lectureId ? { ...lec, checked: newValue } : lec
      )
    }));
  };

  const handleSelectTraining = (t) => {
    setSelected(t);
    fetchSections(t.id);
    if (isMobile) setMobileStep('sections');
  };

  const handleSelectLecture = (lec, isActive, sectionId) => {
    setActiveLecture(isActive ? null : lec);
    setActiveSectionId(isActive ? null : sectionId);
    if (isActive) setShowLectureDetailModal(false);
    if (isMobile && !isActive) setMobileStep('detail');
  };

  const handleCloseDetail = () => {
    setActiveLecture(null);
    setActiveSectionId(null);
    setShowLectureDetailModal(false);
    if (isMobile) setMobileStep('sections');
  };

  const handleRefreshLecture = async (lectureId) => {
    if (!activeSectionId || !groupId) return;
    try {
      const res = await apiFetch(`${BASE_URL}/lectures/get-group-section-lectures-with-details`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sectionId: activeSectionId, groupId })
      });
      const data = await res.json();
      const refreshed = (data.lectures || []).slice().sort((a, b) => (a.counter ?? 0) - (b.counter ?? 0));
      setLectures(p => ({ ...p, [activeSectionId]: refreshed }));
      const updated = refreshed.find(l => l.id === lectureId);
      if (updated) setActiveLecture(updated);
    } catch (e) { console.error('Dərs yenilənmədi:', e); }
  };

  const handleBackToTrainings = () => {
    setMobileStep('trainings');
  };

  /* ── Panellərin görünürlüyü ──
     mobile  < 768px:  bir panel, addım-addım
     desktop >= 768px: bütün panellər həmişə yan-yana */
  const showTrainings = !isMobile || mobileStep === 'trainings';
  const showSections  = !isMobile || mobileStep === 'sections';
  const showDetail    = isMobile ? mobileStep === 'detail' : !!activeLecture;

  /* ── Mobil/Tablet breadcrumb ── */
  const MobileBreadcrumb = () => {
    if (bp === 'desktop') return null;
    const steps = [
      { key: 'trainings', label: 'Təlimlər' },
      ...(selected ? [{ key: 'sections', label: selected.name }] : []),
      ...(activeLecture && mobileStep === 'detail' ? [{ key: 'detail', label: parseLang(activeLecture.name, apiSector) }] : []),
    ];
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 4,
        padding: '6px 12px', background: 'var(--bg-elevated)',
        borderBottom: '1px solid var(--border)', flexShrink: 0, overflowX: 'auto',
        whiteSpace: 'nowrap'
      }}>
        {steps.map((s, i) => (
          <React.Fragment key={s.key}>
            {i > 0 && <i className="bi bi-chevron-right" style={{ fontSize: 9, color: '#d1d5db', flexShrink: 0 }} />}
            <button
              onClick={() => {
                if (s.key === 'trainings') { setMobileStep('trainings'); }
                else if (s.key === 'sections') { setMobileStep('sections'); setActiveLecture(null); }
              }}
              style={{
                border: 'none', background: 'none', padding: '2px 4px',
                fontSize: 11, fontWeight: i === steps.length - 1 ? 700 : 500,
                color: i === steps.length - 1 ? 'var(--primary)' : 'var(--text-muted)',
                cursor: i === steps.length - 1 ? 'default' : 'pointer',
                maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis'
              }}
            >{s.label}</button>
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, background: '#fff' }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeInModal {
          from { opacity: 0; transform: scale(0.95); }
          to   { opacity: 1; transform: scale(1); }
        }
        .spin-icon { animation: spin 0.7s linear infinite; display: inline-block; }
      `}</style>

      <div className={styles.tableToolbar}>
        <div className={styles.toolbarActionsLeft}>
          {/* Mobil/Tablet: geri düyməsi */}
          {isMobile && mobileStep !== 'trainings' && (
            <button
              onClick={mobileStep === 'detail' ? handleCloseDetail : handleBackToTrainings}
              style={{
                width: 28, height: 28, border: '1px solid var(--border)', borderRadius: 6,
                background: '#fff', color: 'var(--text-muted)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
              }}
            >
              <i className="bi bi-arrow-left" style={{ fontSize: 13 }}></i>
            </button>
          )}
          <PageInfoModal title="Dərslər" items={DERSLER_INFO_ITEMS} />
        </div>
        <div className={styles.toolbarActionsRight}>
          <ReloadButton onClick={fetchTrainings} loading={loading} />
        </div>
      </div>

      <MobileBreadcrumb />

      <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>

        {/* SOL — TƏLİMLƏR */}
        {showTrainings && (
          <div style={{
            width: isMobile ? '100%' : 180,
            minWidth: isMobile ? 0 : 160,
            flexShrink: 0,
            borderRight: isMobile ? 'none' : '1px solid var(--border)',
            background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden'
          }}>
            <PanelHeader label="Təlimlər" />
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {loading && (
                <div style={{ padding: '30px 0', display: 'flex', justifyContent: 'center' }}>
                  <AppSpinner text="Yüklənir..." />
                </div>
              )}
              {!loading && trainings.length === 0 && (
                <div style={{ padding: '40px 12px', textAlign: 'center', color: 'var(--text-muted)' }}>
                  <i className="bi bi-collection" style={{ fontSize: 24, marginBottom: 6, display: 'block', color: '#d1d5db' }}></i>
                  <p style={{ fontSize: 11, margin: 0 }}>Təlim tapılmadı</p>
                </div>
              )}
              {!loading && trainings.map(t => {
                const isSel = selected?.id === t.id;
                return (
                  <div key={t.id}
                    onClick={() => handleSelectTraining(t)}
                    style={{
                      padding: '10px 12px', borderBottom: '1px solid #f3f4f6',
                      borderLeft: `3px solid ${isSel ? 'var(--primary)' : 'transparent'}`,
                      background: isSel ? 'var(--primary-glow)' : 'transparent',
                      cursor: 'pointer', transition: 'all 0.15s', userSelect: 'none'
                    }}
                    onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = 'var(--bg-elevated)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = isSel ? 'var(--primary-glow)' : 'transparent'; }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                      <span style={{
                        background: isSel ? 'var(--primary-glow)' : '#eff6ff',
                        color: isSel ? 'var(--primary)' : '#1d4ed8',
                        border: `1px solid ${isSel ? 'var(--primary)' : '#bfdbfe'}`,
                        borderRadius: 4, fontSize: 10, fontWeight: 700, padding: '1px 5px', flexShrink: 0
                      }}>#{t.id}</span>
                      <span style={{
                        fontSize: 12, fontWeight: 600,
                        color: isSel ? 'var(--primary)' : 'var(--text-primary)',
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                      }}>{t.name}</span>
                    </div>
                    {t.description && (
                      <p style={{ fontSize: 11, color: 'var(--text-muted)', margin: '2px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        title={t.description}>{t.description}</p>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>
                        {t.register ? t.register.split(' ')[0] : ''}
                      </span>
                      {isMobile && (
                        <i className="bi bi-chevron-right" style={{ fontSize: 11, color: isSel ? 'var(--primary)' : '#d1d5db' }} />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ORTA — BÖLMƏLƏR */}
        {showSections && (
          <div style={{
            width: isMobile ? '100%' : (showDetail ? 260 : undefined),
            flex: isMobile ? 'none' : (showDetail ? 'none' : 1),
            borderRight: !isMobile && showDetail ? '1px solid var(--border)' : 'none',
            background: '#fafafa', overflow: 'auto', transition: 'all 0.2s',
            display: 'flex', flexDirection: 'column'
          }}>
            {!selected ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, color: 'var(--text-muted)' }}>
                <div style={{ textAlign: 'center' }}>
                  <i className="bi bi-layout-text-sidebar-reverse" style={{ fontSize: 32, marginBottom: 8, display: 'block', color: '#d1d5db' }}></i>
                  <p style={{ fontSize: 12, margin: 0 }}>Sol tərəfdən təlim seçin</p>
                </div>
              </div>
            ) : (
              <>
                <PanelHeader label="Bölmələr" />
                <div style={{ flex: 1, overflow: 'auto', padding: '12px' }}>
                  {sectionsLoading && (
                    <div style={{ padding: '30px 0', display: 'flex', justifyContent: 'center' }}>
                      <AppSpinner text="Bölmələr yüklənir..." />
                    </div>
                  )}
                  {!sectionsLoading && sections.length === 0 && (
                    <div style={{ padding: '40px 12px', textAlign: 'center', color: 'var(--text-muted)' }}>
                      <i className="bi bi-folder2-open" style={{ fontSize: 24, marginBottom: 6, display: 'block', color: '#d1d5db' }}></i>
                      <p style={{ fontSize: 11, margin: 0 }}>Bölmə tapılmadı</p>
                    </div>
                  )}
                  {!sectionsLoading && sections.map((sec, idx) => {
                    const isOpen = !!openSections[sec.id];
                    const secLectures = lectures[sec.id] || [];
                    const isLecLoading = !!lecturesLoading[sec.id];
                    const checkedCount = secLectures.filter(l => l.checked).length;

                    return (
                      <div key={sec.id} style={{
                        marginBottom: 6, borderRadius: 8, overflow: 'hidden',
                        border: `1px solid ${isOpen ? 'var(--primary)' : 'var(--border)'}`,
                        boxShadow: isOpen ? '0 2px 8px rgba(168,85,247,0.1)' : '0 1px 2px rgba(0,0,0,0.04)',
                        transition: 'all 0.2s', background: '#fff'
                      }}>
                        <div onClick={() => toggleSection(sec.id)} style={{
                          display: 'flex', alignItems: 'center', gap: 8,
                          padding: '9px 12px', cursor: 'pointer',
                          background: isOpen ? 'var(--primary-glow)' : '#fff',
                          transition: 'background 0.15s', userSelect: 'none'
                        }}>
                          <span style={{
                            width: 20, height: 20, borderRadius: '50%',
                            background: isOpen ? 'var(--primary)' : 'var(--bg-elevated)',
                            color: isOpen ? '#fff' : 'var(--text-muted)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 10, fontWeight: 700, flexShrink: 0
                          }}>{idx + 1}</span>
                          <span
                            title={parseLang(sec.name, apiSector)}
                            style={{
                            fontSize: 12, fontWeight: 700, flex: 1,
                            color: isOpen ? 'var(--primary)' : 'var(--text-primary)',
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                          }}>{parseLang(sec.name, apiSector)}</span>

                          {isOpen && secLectures.length > 0 && (
                            <span style={{
                              fontSize: 9, fontWeight: 700, padding: '1px 6px',
                              background: checkedCount > 0 ? 'rgba(16,185,129,0.12)' : '#f3f4f6',
                              color: checkedCount > 0 ? '#059669' : 'var(--text-muted)',
                              border: `1px solid ${checkedCount > 0 ? 'rgba(16,185,129,0.3)' : 'var(--border)'}`,
                              borderRadius: 8, flexShrink: 0
                            }}>{checkedCount}/{secLectures.length}</span>
                          )}

                          <svg width="12" height="12" viewBox="0 0 14 14" fill="none"
                            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s', flexShrink: 0 }}>
                            <path d="M3 5l4 4 4-4" stroke={isOpen ? 'var(--primary)' : '#9ca3af'} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>

                        {isOpen && (
                          <div style={{ borderTop: '1px solid var(--border)', background: '#fafafa' }}>
                            {isLecLoading && (
                              <div style={{ padding: '12px 0', display: 'flex', justifyContent: 'center' }}>
                                <AppSpinner text="Dərslər..." />
                              </div>
                            )}
                            {!isLecLoading && secLectures.length === 0 && (
                              <div style={{ padding: '12px', textAlign: 'center', color: '#9ca3af', fontSize: 11 }}>
                                📚 Dərs yoxdur
                              </div>
                            )}
                            {!isLecLoading && secLectures.map((lec, lIdx) => {
                              const isActive = activeLecture?.id === lec.id;
                              return (
                                <LectureItem
                                  key={lec.id}
                                  lec={lec}
                                  lIdx={lIdx}
                                  isActive={isActive}
                                  groupId={groupId}
                                  apiSector={apiSector}
                                  onSelect={(l) => handleSelectLecture(l, isActive, sec.id)}
                                  onCheckedChange={(lectureId, newValue) =>
                                    handleCheckedChange(sec.id, lectureId, newValue)
                                  }
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        )}

        {/* SAĞ — DƏRS DETALİ */}
        {showDetail && activeLecture && (
          <div style={{
            flex: 1, minWidth: 0,
            borderLeft: !isMobile ? '1px solid var(--border)' : 'none',
            overflow: 'hidden',
            width: isMobile ? '100%' : undefined
          }}>
            <LectureDetail
              lecture={activeLecture}
              onClose={handleCloseDetail}
              apiSector={apiSector}
              onRefreshLecture={handleRefreshLecture}
              onOpenManageModal={() => setShowLectureDetailModal(true)}
            />
          </div>
        )}
      </div>

      <LectureDetailModal
        show={showLectureDetailModal && !!activeLecture?.id}
        onHide={() => setShowLectureDetailModal(false)}
        lectureId={activeLecture?.id}
      />
    </div>
  );
};

export default LectureManager;
